module.exports = __webpack_public_path__ + "media/images/swifticons/partybloop-88002283f639675f40ee006d11f3c5c1.svg";